angular.module('impactx.lot').controller('LotDetailCtrl', LotDetailCtrl);
LotDetailCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'RedirectAndSaveService',
    '$redirect',
    '$config',
    'AppConfiguration',
    'ToastService',
    'TranslationService',
    'BackFactory',
    'ToolbarService',
    'AttachmentUploadService'
];

function LotDetailCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, RedirectAndSaveService,
                       $redirect, $config, AppConfiguration, ToastService, TranslationService, BackFactory, ToolbarService,
                       AttachmentUploadService) {
    var self = this;

    $scope.showInactiveRfqc = false;
    $scope.options = {timeStripZeroSeconds: true};
    $scope.showInactiveInheritedRfqc = false;


    function removeEmptyClassifications() {
        for (var i = $scope.data.classifications.assigned.length - 1; i >= 0; i--) {
            var assigned = $scope.data.classifications.assigned[i];
            if ((assigned.selected && assigned.selected.id <= 0) || (assigned.freeSelection && !assigned.freeSelection.value)) {
                $scope.data.classifications.assigned.splice(i, 1);
            }
        }
    }

    self.lotUploadConfig = function () {
        return { url: '/lot/attachment/add', idParam: 'lotId', id: $scope.data.id };
    }

    self.save = function () {
        removeEmptyClassifications();
        let pending = AttachmentUploadService.extractPendingUploads($scope.data.attachments);
        var dataObj = {
            lot: $scope.data
        };
        return dataGen.postAsForm({}, dataObj, "/lot/save")
            .then(function (savedData) {
                if (savedData.data.id) {
                    $scope.data.id = savedData.data.id;
                }
                return AttachmentUploadService.uploadPendingAttachments(self.lotUploadConfig(), pending);
            })
            .then(function () {
                BackService.back();
                $mdToast.show($mdToast.simple().textContent($scope.trns.saveSuccess).position("bottom right").hideDelay(10000));
            })
            .catch(function () {
                AttachmentUploadService.restorePendingUploads($scope.data.attachments, pending);
            });
    };

    self.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    self.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/lot/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    var lotId = $routeParams.id;
    if (lotId <= 0) {
        lotId = BackFactory.getLotId();
    }
    dataGen.getData($scope, {id: lotId}, "/lot/viewdetail").then(function () {
        defineButtons();
    });

    self.saveAndRedirectLotSupplier = function () {
        removeEmptyClassifications();
        var pending = AttachmentUploadService.extractPendingUploads($scope.data.attachments);
        var dataObj = {
            lot: $scope.data
        };
        dataGen.postAsForm({}, dataObj, "/lot/save")
            .then(function (savedData) {
                if (savedData.data.id) {
                    $scope.data.id = savedData.data.id;
                }
                return AttachmentUploadService.uploadPendingAttachments(self.lotUploadConfig(), pending);
            })
            .then(function () {
                self.redirectLotSupplier();
                $mdToast.show($mdToast.simple().textContent($scope.trns.saveSuccess).position("bottom right").hideDelay(10000));
            })
            .catch(function () {
                AttachmentUploadService.restorePendingUploads($scope.data.attachments, pending);
            });
    };

    self.redirectLotSupplier = function () {
        $redirect.redirectTo(null, "/lotsupplierlist/" + $scope.data.id);
    };

    self.saveAndRedirectLotBuyer = function () {
        removeEmptyClassifications();
        var pending = AttachmentUploadService.extractPendingUploads($scope.data.attachments);
        var dataObj = {
            lot: $scope.data
        };
        dataGen.postAsForm({}, dataObj, "/lot/save")
            .then(function (savedData) {
                if (savedData.data.id) {
                    $scope.data.id = savedData.data.id;
                }
                return AttachmentUploadService.uploadPendingAttachments(self.lotUploadConfig(), pending);
            })
            .then(function () {
                self.redirectLotBuyer();
                $mdToast.show($mdToast.simple().textContent($scope.trns.saveSuccess).position("bottom right").hideDelay(10000));
            })
            .catch(function () {
                AttachmentUploadService.restorePendingUploads($scope.data.attachments, pending);
            });
    };

    self.redirectLotBuyer = function () {
        $redirect.redirectTo(null, "/lotbuyerlist/" + $scope.data.id);
    };

    self.showLotBuyer = function (event) {
        if ($scope.data.readOnly || $scope.dialogData.$pristine) {
            $redirect.redirectTo(null, "/lotbuyerlist/" + $scope.data.id);
        }
        else {
            if ($scope.data.id > 0) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectLotBuyer, self.redirectLotBuyer, event,
                    $scope.trns.saveMessageRedirect, $scope.trns.save, $scope.trns.abort, $scope.trns.noSave,
                    false);
            }
            else {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectLotBuyer, self.redirectLotBuyer, event,
                    $scope.trns.saveMessageRedirect, $scope.trns.save, $scope.trns.abort, $scope.trns.noSave,
                    true);
            }
        }
    };

    self.showLotSupplier = function (event) {
        if ($scope.data.readOnly || $scope.dialogData.$pristine) {
            $redirect.redirectTo(null, "/lotsupplierlist/" + $scope.data.id);
        }
        else {
            if ($scope.data.id > 0) {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectLotSupplier, self.redirectLotSupplier, event,
                    $scope.trns.saveMessageRedirect, $scope.trns.save, $scope.trns.abort, $scope.trns.noSave,
                    false);
            }
            else {
                RedirectAndSaveService.showRedirectAndSaveDialog(self.saveAndRedirectLotSupplier, self.redirectLotSupplier, event,
                    $scope.trns.saveMessageRedirect, $scope.trns.save, $scope.trns.abort, $scope.trns.noSave,
                    true);
            }
        }
    };

    self.updateContractType = function (selected) {
        var tenderId = impactX.isDefined(selected, "id");
        if (tenderId) {
            dataGen.getData({}, {tenderId: tenderId}, "/lot/contractType").then(function (data) {
                $scope.contractType = impactX.isDefined(data, "data.contractType");
                $scope.gzBase = impactX.isDefined(data, "data.gzBase");
            })
        }
    };

    $scope.tinymceOptions = $config.tinymceOptions;
    $scope.isClassificationRequired = AppConfiguration.get('requiredClassificationForTenderAndLot');

    self.addAdditionalCPV = function () {
        if (!impactX.isDefined($scope, 'data.additionalCPVs')) {
            $scope.data.additionalCPVs = [];
        }
        $scope.data.additionalCPVs.push({});
    };

    self.removeAdditionalCPV = function (cpv) {
        var index = $scope.data.additionalCPVs.indexOf(cpv);
        if (index >= 0) {
            $scope.data.additionalCPVs.splice(index, 1);
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.lotBuyer,
                action: self.showLotBuyer,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.lotSupplier,
                action: self.showLotSupplier,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return !$scope.data.readOnly && !$scope.data.mainPartReadOnly && $scope.data.id > 0;
    }
}